__webpack_require__.p = "/ptype1/";